<div class="header-bar">
  <h1>Job Match Settings</h1>
</div>
<div class="content-container pb-2">
  <div class="card">
    <div class="flex flex-wrap">
      <div class="flex-shrink-1">
        <div class="select-setting-label">Setting Profile:&nbsp;</div>
      </div>
      <div class="flex-grow-1" style="padding-top: 5px">
        <p-dropdown
          name="profile"
          [style]="{ width: '100%' }"
          [options]="autoMatchChoices"
          [(ngModel)]="selectedSettingsId"
          (onChange)="editSettings(selectedSettingsId)"
          filter="true"
        ></p-dropdown>
      </div>
      <div class="flex-shrink-1">
        <button
          pButton
          icon="fa fa-plus-circle"
          label="New Setting Profile"
          (click)="newSetting()"
        ></button>
      </div>
    </div>
  </div>
</div>

<div class="">
  <div class="" *ngIf="showEditSettings">
    <p-tabView #tabView (onChange)="onTabChange($event)" class="tab-padding no-widget-border">
      <p-tabPanel header="Settings" #tabSettings>
        <ng-template pTemplate="content">
          <form [formGroup]="formGroup" class="filterPanel">
            <div class="ui-g">
              <div class="ui-lg-6" style="box-sizing: border-box">
                <div class="ui-g-7 label">Enabled:</div>
                <div class="ui-g-5">
                  <p-inputSwitch formControlName="enabled"></p-inputSwitch>
                </div>

                <div class="ui-g-7 label">
                  <label for="profileName">Setting Title:</label>
                </div>

                <div class="ui-g-5 input-field">
                  <input pInputText formControlName="profileName" id="profileName" />
                </div>
                <div class="ui-g-7 label">
                  <label for="minWeightKg">Min Weight (kg):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input pInputText formControlName="minWeightKg" type="number" id="minWeightKg" />
                </div>
                <div class="ui-g-7 label">
                  <label for="maxWeightKg">Max Weight (kg):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input pInputText formControlName="maxWeightKg" type="number" id="maxWeightKg" />
                </div>

                <div class="ui-g-7 label">Fuel Types:</div>
                <div class="ui-g-5 input-field">
                  <p-multiSelect
                    [options]="fuelTypes"
                    formControlName="fuelTypeInclusionsArray"
                  ></p-multiSelect>
                </div>

                <div class="ui-g-7 label">Exclude MultiTask Jobs:</div>
                <div class="ui-g-5 input-field">
                  <p-inputSwitch formControlName="excludeMultiTaskJobs"></p-inputSwitch>
                </div>

                <div class="ui-g-7 label">
                  <label for="matchingWaitTimeInMinutes">Match Waiting Time (Minutes):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="matchingWaitTimeInMinutes"
                    type="number"
                    id="matchingWaitTimeInMinutes"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Maximum minutes driver will wait at 1st leg Drop off before 2nd leg Pick up."
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="totalJobDurationMinutes">Total Job Duration (Minutes):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="totalJobDurationMinutes"
                    type="number"
                    id="totalJobDurationMinutes"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Maximum duration in minutes of sum of individual task times "
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="timeWindowWidthHours">Time Window (Hours):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="timeWindowWidthHours"
                    type="number"
                    id="timeWindowWidthHours"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="The time window width of second leg pick-up"
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="abbaMatchingAdditionalRadiusPer100Miles"
                    >ABBA Matching Radius/100m:</label
                  >
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="abbaMatchingAdditionalRadiusPer100Miles"
                    type="number"
                    id="abbaMatchingAdditionalRadiusPer100Miles"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Matching additional radius per 100 miles for ABBA matches"
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="abbaMatchingMaximumRadius">ABBA Maximum Matching Radius:</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="abbaMatchingMaximumRadius"
                    type="number"
                    id="abbaMatchingMaximumRadius"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Maximum matching radius for ABBA matches"
                  ></i>
                </div>
              </div>

              <div class="ui-lg-6" style="box-sizing: border-box">
                <div class="ui-g-7 label">
                  <label for="minTimeToLatestPickUpHours"
                    >Min. Time To Latest Pickup (Hours):</label
                  >
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="minTimeToLatestPickUpHours"
                    type="number"
                    id="minTimeToLatestPickUpHours"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Allowed minutes before pickup latest time job can still be matched."
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="atoDMaxDistanceMiles">A-D Max Distance (Miles):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="atoDMaxDistanceMiles"
                    type="number"
                    id="atoDMaxDistanceMiles"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Maximum allowed distance between 1st Leg Pickup and 2nd leg Drop Off"
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="atoDMaxTravelTimeMinutes">A-D Max Duration (Minutes):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="atoDMaxTravelTimeMinutes"
                    type="number"
                    id="atoDMaxTravelTimeMinutes"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Maximum allowed public transport time between 1st Leg Pickup and 2nd leg Drop Off"
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="rRatio">R.Ratio:</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input pInputText formControlName="rRatio" type="number" id="rRatio" />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Maximum Allowed R ratio – R ratio 0 to 1 depending on viability of match 1 being perfect ABBA 0.5 being a straight line ABBC."
                  ></i>
                </div>
                <div class="ui-g-7 label">
                  <label for="rRatioLessThanDay">R.Ratio Less Than Day:</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="rRatioLessThanDay"
                    type="number"
                    id="rRatioLessThanDay"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Maximum Allowed R ratio for jobs where total job duration < LessThanADaysWorkHours"
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="minLeewayMinutes">Min Leeway (Minutes):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="minLeewayMinutes"
                    type="number"
                    id="minLeewayMinutes"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Time driver has to get between Drop off of first leg and Pickup of second leg NOT accounting for public transport time."
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="minTransitLeewayMinutes">Min Transit Leeway (Minutes):</label>
                </div>

                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="minTransitLeewayMinutes"
                    type="number"
                    id="minTransitLeewayMinutes"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Time driver has to get between Drop off of first leg and Pickup of second leg accounting for public transport time."
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="lessThanDaysWorkHours">Less Than Days Work (Hours):</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="lessThanDaysWorkHours"
                    type="number"
                    id="lessThanDaysWorkHours"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Max hours job considered Less than a days work and subject to this logic"
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="matchingRadiusPickup">Matching Pickup Radius:</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="matchingRadiusPickup"
                    type="number"
                    id="matchingRadiusPickup"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Matching pickup radius"
                  ></i>
                </div>

                <div class="ui-g-7 label">
                  <label for="matchingRadiusDropoff">Matching Dropoff Radius:</label>
                </div>
                <div class="ui-g-5 input-field">
                  <input
                    pInputText
                    formControlName="matchingRadiusDropoff"
                    type="number"
                    id="matchingRadiusDropoff"
                  />
                  <i
                    class="fa fa-question-circle tooltip"
                    tooltipPosition="bottom"
                    tooltipStyleClass="xtooltip"
                    pTooltip="Matching dropoff radius"
                  ></i>
                </div>
              </div>
            </div>

            <div class="p-2" style="text-align: right">
              <button
                type="button"
                (click)="deleteSetting()"
                pButton
                label="Delete Profile"
                class="mr-1 ui-button-danger"
              ></button>
              <button
                type="button"
                (click)="saveSetting()"
                pButton
                label="Save Settings Profile"
                class="ui-button-primary"
              ></button>
            </div>

            <div class="ui-g mt-2">
              <div class="ui-g-6">
                <p-table
                  [value]="includedCustomers"
                  [rows]="10"
                  [paginator]="true"
                  selectionMode="single"
                  [(selection)]="excludeItem"
                  #dt
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Included Customers</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-item>
                    <tr (dblclick)="moveToExcluded(item)" [pSelectableRow]="item">
                      <td>{{ item.label }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <div class="ui-g-6">
                <p-table
                  [value]="excludedCustomers"
                  [rows]="10"
                  [paginator]="true"
                  selectionMode="single"
                  [(selection)]="includeItem"
                  #dt
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Excluded Customers</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-item>
                    <tr (dblclick)="moveToIncluded(item)" [pSelectableRow]="item">
                      <td>{{ item.label }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </form>

          <div style="text-align: right">
            <button
              type="button"
              (click)="deleteSetting()"
              pButton
              label="Delete Profile"
              class="mr-1 ui-button-danger"
            ></button>
            <button
              type="button"
              (click)="saveSetting()"
              pButton
              label="Save Settings Profile"
              class="ui-button-primary"
            ></button>
          </div>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel header="Matches" #tabMatches>
        <ng-template pTemplate="content">
          <h1 *ngIf="matchedJobsData">No. of matched jobs: {{ matchedJobsData.length }}</h1>

          <p-table
            [value]="matchedJobsData"
            [rows]="50"
            [paginator]="true"
            selectionMode="single"
            [(selection)]="selectedMatchedJob"
            (selectionChange)="showMatchData($event)"
            [loading]="loadingMatches"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Job Number</th>
                <th>From Postcode</th>
                <th>To Postcode</th>
                <th>Total Distance</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr [pSelectableRow]="item">
                <td>
                  <a
                    *ngIf="item.jobNumber"
                    target="_blank"
                    [routerLink]="['/app/jobscreen', item.id]"
                    >{{ item.jobNumber }}</a
                  >
                </td>
                <td>{{ item.from }}</td>
                <td>{{ item.to }}</td>
                <td>{{ item.totalDistance | number }} miles</td>
              </tr>
            </ng-template>
          </p-table>

          <div class="match-data" *ngIf="viewMatch">
            <p-table
              [value]="viewMatch.orders"
              [rows]="10"
              [paginator]="true"
              selectionMode="single"
              [(selection)]="viewMatchOrder"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Order Number</th>
                  <th>Customer Price</th>
                  <th>Min Price</th>
                  <th>Max Price</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-item>
                <tr [pSelectableRow]="item">
                  <td>{{ item.orderNumber }}</td>
                  <td>{{ item.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
                  <td>{{ item.minPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
                  <td>{{ item.maxPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div class="match-data" *ngIf="viewMatchOrder">
            <p-table
              [value]="viewMatchOrder.tasks"
              [rows]="10"
              [paginator]="true"
              selectionMode="single"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Pickup Postcode</th>
                  <th>Pickup Early</th>
                  <th>Pickup Late</th>
                  <th>Dropoff Postcode</th>
                  <th>Dropoff Early</th>
                  <th>Dropoff Late</th>
                  <th>Distance</th>
                  <th>TaskType</th>
                  <th>Registration</th>
                  <th>Weight</th>
                  <th>Make</th>
                  <th>Model</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr [pSelectableRow]="item">
                  <td>{{ item.pickupPostcode }}</td>
                  <td>{{ item.pickupEarliest | datex : "ddd DD MMM 'YY HH:mm" }}</td>
                  <td>{{ item.pickupLatest | datex : "ddd DD MMM 'YY HH:mm" }}</td>
                  <td>{{ item.dropoffPostcode }}</td>
                  <td>{{ item.dropoffEarliest | datex : "ddd DD MMM 'YY HH:mm" }}</td>
                  <td>{{ item.dropoffLatest | datex : "ddd DD MMM 'YY HH:mm" }}</td>
                  <td>{{ item.distance }}</td>
                  <td>{{ item.taskType }}</td>
                  <td>{{ item.vehicleReg }}</td>
                  <td>{{ item.vehicleWeight }}</td>
                  <td>{{ item.vehicleMake }}</td>
                  <td>{{ item.vehicleModel }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<p-dialog
  #newSettingDialog
  header=""
  [(visible)]="showNewSettingsDialog"
  [responsive]="true"
  [modal]="true"
>
  <p-header>Create Match Settings Profile</p-header>

  <div>
    <label for="newProfileName">New Profile Name:</label>
    <input pInputText [(ngModel)]="newProfileName" id="newProfileName" />
  </div>

  <div style="text-align: right; padding-top: 20px">
    <button pButton type="button" (click)="showNewSettingsDialog = false" label="Cancel"></button>
    <button
      pButton
      type="button"
      (click)="createSettings()"
      class="ui-button-success"
      label="Continue"
    ></button>
  </div>
</p-dialog>

<p-dialog
  #deleteSettingDialog
  header=""
  [(visible)]="showDeleteSettingsDialog"
  [responsive]="true"
  [modal]="true"
>
  <p-header>Delete Confirmation</p-header>

  <div style="text-align: center">Confirm you would want to delete this Settings record</div>

  <div style="text-align: right; padding-top: 20px">
    <button
      type="button"
      (click)="showDeleteSettingsDialog = false"
      pButton
      label="Cancel"
    ></button>
    <button
      type="button"
      (click)="confirmDeleteSetting()"
      pButton
      label="Delete"
      class="mr-1 ui-button-danger"
    ></button>
  </div>
</p-dialog>
